import { TranslationsContext } from '@teliaee/telia-translate';
import { format, parse } from 'date-fns';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Container, Grid, GridColumn, Heading, IButtonProps, Separator, Tag, Text } from 'telia-front-react';
import LanguageStore from '../stores/LanguageStore';

export interface NewsDetailsProps {
  title: string;
  displayDate: string;
  languageStore?: LanguageStore;
  children: React.ReactChild | React.ReactChild[];
  buttonText?: string;
  tags?: string[];
}

@observer
class NewsDetailsContainer extends React.Component<NewsDetailsProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  private buildButton(): IButtonProps {
    const translate = this.context.translate;
    const { buttonText } = this.props;

    return {
      text: buttonText || translate('newsDetails.viewAllButtonText'),
      url: translate('newsDetails.viewAllButtonUrl')
    };
  }

  public render() {
    const { title, displayDate, children, tags, languageStore } = this.props;
    const button = this.buildButton();
    const resolvedDateFormat = 'd. MMMM yyyy';

    return (
      <Container>
        <Grid>
          <GridColumn width={['xs-12', 'sm-6', 'lg-8']}>
            <Text>
              <Heading className="h2">{title}</Heading>
              <div>
                <div className="text-small">
                  <Grid className="text-small" gutter="xsmall">
                    <GridColumn width={['xs']}>
                      <time dateTime={displayDate}>
                        {format(parse(displayDate, 'dd.MM.yyyy', Date.now()), resolvedDateFormat, { locale: languageStore.currentLocale })}
                      </time>
                    </GridColumn>
                    <GridColumn width={['xs']}>{!!tags?.length && tags.map((tag, idx) => <Tag key={`${tag}-${idx}`} text={tag} size="tiny" />)}</GridColumn>
                  </Grid>
                </div>
              </div>
              <Text className="text__margin-double">{children}</Text>
              <Separator spacing="small" color="invisible" />
              <Button variant="secondary" iconLeft="#arrow-left" {...button} />
            </Text>
          </GridColumn>
        </Grid>
      </Container>
    );
  }
}

export default inject('languageStore')(NewsDetailsContainer);
